import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const Yoga = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'Yoga & Meditation',
    category: 'Wellness',
    description: 'Holistic wellness through yoga and meditation practices.',
    longDescription: 'Find balance and peace with our Yoga & Meditation program. Offering a variety of styles from Hatha to Vinyasa, along with guided meditation sessions, we provide tools for physical and mental wellbeing. Our experienced instructors create a welcoming environment for practitioners of all levels.',
    images: [
      getImagePath('images/bars/Yoga.jpg'),
      getImagePath('images/bars/Yoga.jpg'),
      getImagePath('images/bars/Yoga.jpg')
    ],
    icon: 'fa-om',
    members: '35+ active members',
    instructor: 'Certified Instructor Priya Sharma',
    schedule: 'Mon, Wed, Fri: 7am, 6pm | Sat: 9am',
    level: 'All Levels',
    features: [
      'Hatha Yoga',
      'Vinyasa Flow',
      'Restorative Yoga',
      'Guided Meditation',
      'Pranayama (Breathing)',
      'Workshops',
      'Private Sessions',
      'Retreats'
    ],
    facilities: ['Serene Studio', 'Props Provided', 'Changing Rooms', 'Tea Lounge'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'yoga@nlngraclub.com',
      extension: '217'
    },
    styles: ['Hatha', 'Vinyasa', 'Yin', 'Restorative', 'Prenatal'],
    workshops: ['Meditation Basics', 'Stress Relief', 'Alignment Workshop', 'Weekend Retreats']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>Lead Instructor</h4>
                    <p>{sectionData.instructor}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Class Times</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Styles:</span>
                  <span className="info-value">{sectionData.styles.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Workshops:</span>
                  <span className="info-value">{sectionData.workshops.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join This Section
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-calendar"></i> Class Schedule
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Yoga;